module.exports = __webpack_public_path__ + "img/0445_11.33dde303.jpg";